import axios from 'axios';

export const compareForms = (formId: string) =>
    axios
        .get(`/testapp/compare/${formId}`)
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
